import { jsonProperty, Serializable } from 'ts-serializable';

// Вариант ответа на вопрос в не пройденном опросе
export class SurveyAnswerModel extends Serializable {
  @jsonProperty(Number, null) answerId: number | null = null;
  @jsonProperty(Number, null) questionId: number | null = null;
  @jsonProperty(String, null) descr: string | null = null;
  @jsonProperty(Boolean, null) isTextAnswer: boolean = false;
  @jsonProperty(Number, null) happyIndex: number | null = null; // В дополнительных вопросах отсутствует
  @jsonProperty(String, null) textValue: string | null = null;
  @jsonProperty(Boolean) isChecked: boolean = false;
}
